import { connect } from "react-redux";
import Loading from "../components/Loading";

const mapStateToProps = (state) => {
  return {
    status: state.session.sessionStatus,
  };
};

export const LoadingContainer = connect(
  mapStateToProps,
)(Loading);
